import { Heading } from "../../components/heading/Heading"
import TermsAndConditionsConstants from "./TermsAndConditionsConstants"
import htmlParser from 'html-react-parser'

export const TermsAndConditions = () => {
    return (
        <>
            <Heading level={1}>{TermsAndConditionsConstants.TERMS_OF_USE}</Heading>
            {
                TermsAndConditionsConstants.PARAS.map((p, idx) => (
                    <p key={idx}>{htmlParser(p)}</p>
                ))
            }
        </>
    )
}